import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
export function nonZero(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
            return { nonZero: 'should not be zero' };
        }
        return null;
    };
}
